<template>
  <el-main class="container">
    <div class="form-box">
      <div class="title">精选项目信息</div>

      <div class="input-box">
        <div class="row">
          <div class="item">
            <div class="star">项目名称</div>
            <el-input placeholder="请输入项目名称" class="input" v-model="body.name"></el-input>
          </div>

          <div class="item">
            <div class="star">排列序号</div>
            <el-input placeholder="请输入排列序号" class="input" v-model="body.indexNum" type="number"></el-input>
          </div>

          <div class="item">
            <div class="star">联系电话</div>
            <el-input placeholder="请输入联系电话" class="input" v-model="body.linkPhone"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="star">详细地址</div>
            <el-input placeholder="请输入详细地址" class="input" v-model="body.detailsAddress"></el-input>
          </div>

          <div class="item">
            <div class="star">公共交通</div>
            <el-input placeholder="例：距离「地铁6号线」约60米" class="input" v-model="body.publicTransport"></el-input>
          </div>

          <div class="item">
            <div>总建筑面积</div>
            <el-input placeholder="请输入建筑面积" class="input" v-model="body.coveredArea"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div>产品类型</div>
            <el-input placeholder="例：智能化写字楼" class="input" v-model="body.projectType"></el-input>
          </div>

          <div class="item">
            <div>运营商</div>
            <el-input placeholder="例：安宏基产业" class="input" v-model="body.developers"></el-input>
          </div>

          <div class="item">
            <div>其他</div>
            <el-input placeholder="例：龙华区安宏基天曜广场" class="input" v-model="body.projectAddress"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div>轮播图url</div>
            <el-input placeholder="例：www.baidu.com" class="input" v-model="body.url"></el-input>
          </div>
        </div>
      </div>

      <div class="map-box">
        <div class="star">产业位置</div>
        <!-- <div id="map">
          <div class="search">
            <el-input
              placeholder="请输入地点"
              v-model.trim="searchPlace"
              class="input"
              clearable
              type="text"/>
            <el-button type="primary" @click="handleMapSearch()">搜索</el-button>
          </div>
        </div> -->
        <Map
          class="map-box"
          @getInfo="handleGetMap"
          :locationInfo="location"
        ></Map>
      </div>

      <div class="tag-box">
        <div>精选项目标签：</div>
        <div class="tag-list-box">
          <template v-for="(item ,index) in tagList">
            <div
              :key="index"
              class="tag-item"
              @click="handleClickFun(item)"
              :class="{'active' : selectTagList.indexOf(item.uuid) !== -1}"
            >{{item.name}}</div>
          </template>
        </div>
      </div>

      <div class="img-box">
        <div class="cover-item">
          <div class="img-title">封面图（{{coverNum}}/1）</div>
          <UpLoadImg
            tips="(284*196)"
            :img="banners"
            :length='1'
            :size="[350, 180]"
            @get-files="getbanner"/>
        </div>
        <div class="carousel-item">
          <div class="img-title">轮播图（{{carouselNum}}/6）</div>
          <UpLoadImg
            tips="(750*524)"
            :img="carouselBanners"
            :length='6'
            :size="[350, 180]"
            @get-files="getCarousel"/>
        </div>
      </div>

      <div class="rich-text-box">
        <div>产业介绍</div>
        <wang-editor
          class="rich-text"
          ref="editor"
          @editorContent="getEditorContent"/>
      </div>

      <div class="btn-box">
        <el-button @click="handleReturn">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </div>
  </el-main>
</template>

<script>
import globalVariable from '@/configs/index'
import UpLoadImg from '@/components/upload-img'
import WangEditor from '@/components/Wangeditor/index'
import { TMap } from '@/jslib/tmap'
import { getTagList, addProject, getProjectDetail, updateProject } from '@/api/featured'
import Map from '@/components/Map'
export default {
  data() {
    return {
      tagList: [],
      coverNum: 0,
      carouselNum: 0,
      body: {
        coveredArea: '',
        detailsAddress: '',
        developers: '',
        indexNum: '',
        introduction: '',
        labelUuidList: [],
        latitude: '22.665407780129044',
        linkPhone: '',
        longitude: '113.99657070636749',
        name: '',
        picture: '',
        pictureList: [],
        projectAddress: '',
        projectType: '',
        publicTransport: '',
        url: ''
      },
      searchPlace: '',
      selectTagList: [],
      banners: [],
      carouselBanners: [],
      pageType: 'add',
      uuid: '',
      location: []
    }
  },
  async created() {
    await this.network().getTagList()
    if (this.$route.params.id) {
      this.uuid = this.$route.params.id
      this.pageType = 'set'
      await this.network().getProjectDetail(this.$route.params.id)
    }
  },
  mounted(){
    this.location = globalVariable.defaultLocation // 默认地址 安宏基经纬度
  },
  methods: {
    network() {
      return {
        getTagList: async() => {
          const { data } = await getTagList()
          this.tagList = data.list
        },
        addProject: async() => {
          await addProject(this.body)
          this.$message.success('添加成功')
          this.$router.push('/project-list')
        },
        getProjectDetail:(id) => {
          getProjectDetail(id).then(res => {
            let data = res.data
            for (const key in this.body) {
              const val = data[key]
              if (val) {
                this.body[key] = val
              }
            }
            this.location = []
            this.location.push(data.latitude)
            this.location.push(data.longitude)

            data.picture ? this.coverNum = 1 : this.coverNum = 0
            data.pictureList.length > 0 ? this.carouselNum = data.pictureList.length : this.carouselNum = 0
            this.banners = this.body.picture
            this.carouselBanners = this.body.pictureList
            this.selectTagList = this.body.labelUuidList
            this.$refs.editor.setHtml(this.body.introduction)
          })
        },
        updateProject: async() => {
          let data = {
            ...this.body,
            uuid: this.uuid
          }
          await updateProject(data)
          this.$message.success('更新成功')
          this.$router.push('/project-list')
        }
      }
    },
    // 获取编辑器内容
    getEditorContent(data) {
      let html = '<p><br></p>'
      if(data === html){
        this.body.introduction = ''
      } else {
        this.body.introduction = data
      }
    },
    initMap() {
      TMap('X3KBZ-Z376O-HXHW3-SSP2I-4HSZZ-H4FCC').then(qq => {
        var center = new qq.maps.LatLng(this.body.latitude, this.body.longitude)
        var map = new qq.maps.Map(document.getElementById('map'), {
          center: center,
          zoom: 15
        })
        // 点击事件
        // eslint-disable-next-line no-unused-vars
        var listener = qq.maps.event.addListener(map, 'click', (event) => {
          this.body.latitude = event.latLng.getLat()
          this.body.longitude = event.latLng.getLng()
        })
        // 标注
        // eslint-disable-next-line no-unused-vars
        var marker = new qq.maps.Marker({
          position: center,
          map: map
        })
        var callbacks = {
          complete: function(result) {
            map.setCenter(result.detail.location)
            // eslint-disable-next-line no-unused-vars
            var marker = new qq.maps.Marker({
              map: map,
              position: result.detail.location
            })
          }
        }
        this.geocoder = new qq.maps.Geocoder(callbacks)
      })
    },
    handleMapSearch() {
      this.geocoder.getLocation(this.searchPlace)
    },
    handleClickFun(row) {
      if (this.selectTagList.length > 0) {
        let falg = true
        let Index = 0
        this.selectTagList.forEach((item, index) => {
          if (item === row.uuid) {
            falg = false
            Index = index
          }
        })
        falg ? this.selectTagList.push(row.uuid) : this.selectTagList.splice(Index, 1)
      } else {
        this.selectTagList.push(row.uuid)
      }

      this.body.labelUuidList = this.selectTagList
    },
    getbanner(file, files) {
      if (files.length > 0) {
        this.body.picture = files[0].response
        this.coverNum = 1
      } else {
        this.coverNum = 0
      }
    },
    getCarousel(file, files) {
      if (files.length > 0) {
        const res = []
        files.forEach(item => {
          if (item.response === undefined) {
            res.push(item.url)
          } else {
            res.push(item.response)
          }
        })
        this.body.pictureList = res
        this.carouselNum = this.body.pictureList.length
      } else {
        this.carouselNum = 0
      }
    },
    checkForm() {
      const res = {
        'name': '输入项目名称',
        'indexNum': '请输入排列序号',
        'linkPhone': '请输入联系电话',
        'detailsAddress': '请输入详细地址',
        'publicTransport': '请输入公共交通',
        'coveredArea': '请输入建筑面积',
        'projectType': '请输入产品类型',
        'developers': '请输入开发商',
        'projectAddress': '请输入项目地址',
        'url': '请输入轮播图url',
        'introduction': '请输入富文本介绍'
      }
      for (const key in res) {
        const val = this.body[key]
        if (res[key]) {
          if (val === '') {
            this.$message.error(res[key])
            return false
          }
        }
      }

      if (this.body.labelUuidList.length <= 0) {
        this.$message.error('请选择标签')
        return false
      } else if (this.body.picture === '') {
        this.$message.error('请上传封面图')
        return false
      } else if (this.body.pictureList.length <= 0) {
        this.$message.error('请上传轮播图')
        return false
      }
      return true
    },
    handleSubmit() {
      if (this.checkForm()) {
        this.pageType === 'add' ? this.network().addProject() : this.network().updateProject()
      }
    },
    handleReturn() {
      this.$router.go(-1)
    },
    handleGetMap(lat, lng, mapInfo){
      this.$message.success('设置成功')
      this.body.latitude = lat
      this.body.longitude = lng
    }
  },
  components: {
    UpLoadImg,
    WangEditor,
    Map
  }
}
</script>

<style lang="scss" scoped>
.form-box{
  .star{
    &::before{
      content: "*";
      color: red;
      margin-right: 5px;
      font-size: 20px;
    }
  }
  .title{
    font-size: 20px;
    font-weight: bold;
    margin: 15px 0;
  }
  .input-box{
    width: 100%;
    .row{
      display: flex;
      margin: 50px 0;
      .item{
        flex: 1;
        display: flex;
        div{
          display: flex;
          align-items: center;
          width: 130px;
        }
        .input{
          width: 300px;
        }
      }
    }
  }

  .map-box{
    margin-top: 15px;
    width: 1500px;
    height: 600px;
    position: relative;
  }

  .search{
    display: flex;
    width: 400px;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    .input{
      margin-right: 30px;
    }
  }

  .tag-box{
    margin-top: 60px;
    .tag-list-box{
      display: flex;
      margin-top: 30px;
      flex-wrap: wrap;
    }
    .tag-item{
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      user-select: none;
      border-radius: 5px;
      width: 180px;
      height: 70px;
      margin: 0 5px;
      border: 1px solid #000;
    }
    .active{
      background: #169bd5;
      color: #fff;
    }
  }

  .img-box{
    .cover-item{
      margin: 30px 0;
    }
    .carousel-item{
      margin: 30px 0;
    }
    .img-title{
      margin: 30px 0;
    }
  }

  .rich-text-box{
    margin-top: 60px;
    .rich-text{
      margin: 30px 0;
      width: 60%;
    }
  }

  .btn-box{
    margin: 120px 0 30px 0;
    display: flex;
    justify-content: center;
    button{
      height: 40px;
      width: 140px;
    }
  }
}
</style>
